import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { ChevronLeft } from 'lucide-react'
// import { format } from "date-fns";
import { TailSpin } from 'react-loader-spinner'
import { DDGColors } from '../../constants/colors'
import { AppState } from '../../state'
import { getInitials } from '../../functions'
import BookingSteps from '../../components/BookingSteps'
import { useSwitchPage } from '../../state/features/applicationSlice/hooks'
import { ApplicationPages } from '../../state/features/applicationSlice'
import Image from '../../components/Image'
interface startProps {}
const BookingClassStepTwo: React.FC<startProps> = ({}) => {
	const {
		activeBooking,
		activeClass: wellnessClass,
		activeFacility: hospital,
	} = useSelector<AppState, AppState['application']>(
		(state) => state.application
	)

	const router = useSwitchPage()
	if (!hospital) {
		return (
			<div
				style={{ minHeight: 500 }}
				className='relative flex items-center justify-center flex-col flex-grow w-full h-full max-w-lg mx-auto overflow-y-hidden min-h-[300px]'
			>
				<TailSpin width='20' color={DDGColors.primary} />
			</div>
		)
	}
	return (
		<main className='h-full overflow-y-scroll flex flex-col bg-[#F6F9F9]'>
			<div className='relative h-40'>
				{/* Navigation buttons */}
				<div className='absolute z-10 flex flex-row items-center justify-between w-full px-4 top-4'>
					<button
						onClick={() => {
							router(ApplicationPages.BOOKING_CLASS_START)
						}}
						className='flex items-center justify-center w-8 h-8 bg-opacity-50 rounded-full bg-slate-700'
					>
						<ChevronLeft size={20} color='white' />
					</button>
				</div>

				{/* Background image */}
				<div className='relative h-40 bg-gray-800'>
					<div className='absolute w-full h-full bg-black/20'></div>
					<Image
						className='object-cover w-full h-full '
						src={wellnessClass?.image ?? ''}
						alt={wellnessClass?.title ?? ''}
						useBase={false}
					/>
				</div>

				{/* Logo and title */}
				<div className='absolute left-0 flex items-center w-full px-4 bottom-8'>
					<div className='mr-4'>
						<div className='flex items-center justify-center w-12 h-12 overflow-hidden bg-white border-2 border-white rounded-full'>
							<div className='text-xs font-bold text-center text-red-500'>
								<Image
									useBase={false}
									className='flex-1 w-full h-full bg-white border rounded-full p-dark border-primaryLight'
									src={hospital.details.logoImage ?? ''}
									alt={hospital.details.institutionName}
								/>
							</div>
						</div>
					</div>
					<div>
						<h1 className='text-xl font-bold text-white'>
							{wellnessClass?.title ?? ''}
						</h1>
						<div className='text-sm text-white/80'>Accra, Ghana</div>
					</div>
				</div>
			</div>

			<div className='flex flex-col flex-1 space-y-4 bg-white shadow-t-xl shadow-gray700 rounded-t-2xl'>
				<BookingSteps type='CLASS_BOOKING' />
			</div>
		</main>
	)
}
export default BookingClassStepTwo
